import { render, staticRenderFns } from "./RegisteredPartiesList.vue?vue&type=template&id=721b97bd&"
import script from "./RegisteredPartiesList.vue?vue&type=script&lang=js&"
export * from "./RegisteredPartiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports